import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { faAngleDown, faAngleUp, faRightFromBracket, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import authService from '../../services/authService';
import IMAGES from "../../assets";
import { displayUserRole } from '../../utils/Helpers'
import { COLORS } from "../../utils/Colors";
import { CONSTANTS } from "../../utils/Constants";
import { User } from "../../interfaces/Shared";

interface NavItem {
  name: string
  path: string
  icon?: JSX.Element
}

interface AsideProps {
  navItems: NavItem[]
  setIsSidebarOpen: (value: boolean) => void
}

const AppAside: React.FC<AsideProps> = ({
  navItems,
  setIsSidebarOpen
}) => {
  const location = useLocation()
  const navigate = useNavigate()
  const [toggleLogout, setToggleLogout] = useState<boolean>(false)
  const user:User = JSON.parse(localStorage.getItem("user") || '{}')

  const logout = () => {
    setToggleLogout(false)
    localStorage.removeItem("user")
    authService.removeToken()
    navigate('/login')
  }

  return (
    <>
      <figure className="h-[4.5rem] px-4 pt-8">
        <Link to="/" className="">
          <img
						src={IMAGES.logo}
						className="w-1/2"
						alt={CONSTANTS.appTitle}
					/>
        </Link>
      </figure>
      <button className="absolute top-4 right-4" onClick={() => setIsSidebarOpen(false)}>
        <FontAwesomeIcon className="w-5 h-5" icon={faXmark} />
      </button>
      <nav className="flex flex-col space-y-4 flex-1 px-6 pt-12 overflow-y-auto scrollbar-hide">
        {navItems.map((item) => (
          <button key={item.name} className="inline-block flex-col" onClick={() => setIsSidebarOpen(false)}>
            <Link
              to={item.path}
              className={`px-6 py-2 text-lg ${
                location.pathname.endsWith(item.path)
                  ? 'bg-white text-dark-brand font-bold rounded-lg'
                  : 'text-black-accent hover:border-2 ' +
                    'hover:border-main/90 ' +
                    'hover:text-main/90 rounded-lg'
              } flex items-center`}
            >
            {item.icon} <span className="ml-4">{item.name}</span>
            </Link>
          </button>
        ))}
      </nav>
      <button
        data-testid="logout-toggle-button"
        className="flex items-center justify-between p-6 hover:bg-gray/20 cursor-pointer"
        onClick={() => setToggleLogout(!toggleLogout)}
      >
        <div className="flex items-center">
          <div className="w-8 md:w-12 h-8 md:h-12 bg-white text-dark-brand rounded-full flex items-center justify-center bg-main cursor-pointer"
          >
            <p className="text-lg md:text-xl text-yellow-extended font-bold">{user.firstName?.charAt(0).toUpperCase()}</p>
            <p className="text-lg md:text-xl text-yellow-extended font-bold">{user.lastName?.charAt(0).toUpperCase()}</p>
          </div>
          <div className="ml-4 -space-y-1">
            <p className="block font-bold text-black-second">{user?.firstName} {user?.lastName}</p>
            <p className="text-black-accent text-xs text-start">{displayUserRole(user?.rolePermissionsId)}</p>
          </div>
        </div>
        {toggleLogout === true && <FontAwesomeIcon className="w-5 h-5 pr-2" color="white" icon={faAngleUp} />}
        {toggleLogout === false && <FontAwesomeIcon className="w-5 h-5 pr-2" color="white" icon={faAngleDown} />}
      </button>
      {toggleLogout && (
        <div className="p-6">
          <button
            className="w-full flex items-center justify-center gap-2 py-4 px-4 bg-dark-brand rounded-lg text-red-extended cursor-pointer shadow-xl border"
            onClick={logout}
          >
            <FontAwesomeIcon className="w-5 h-5 pr-2" color={COLORS.White} icon={faRightFromBracket} />
            <p className='font-bold'>{CONSTANTS.logout}</p>
          </button>
        </div>
      )}
    </>
  )
}

export default AppAside